module.exports = __webpack_public_path__ + "img/logo_header.3b50ca25.svg";